import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { startVersionChecker } from './utils/versionCheck';
import { initDiag } from './utils/diag';

// Opt-in persistent diagnostics (no-op unless the site was opened with ?diag=1).
// Initialised before render so it captures the earliest lifecycle events.
initDiag();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Register service worker for offline support and cache management
serviceWorkerRegistration.register();

// Start periodic version checking (auto-reloads when a new deploy is detected)
startVersionChecker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
